<template>
  <d-form @submit.prevent>
    <d-list-group class="list-group-flush">
      <d-list-group-item v-for="scope in d_scopes" class="d-flex justify-content-start align-items-center pl-0" :key="`consent.scope.${scope}`">
        <span class="list-item-marker mr-3" />

        {{ $t(`consent.scope.${scope}`) }}
      </d-list-group-item>
    </d-list-group>

    <p class="mt-2">
      {{ $t('consent.request.accountability') }}
    </p>

    <d-row class="align-items-end">
      <d-col>
        <r-button @click="$emit('submit', 'post')" :error="d_request.error" :loading="d_request.loading">
          {{ $t('button.grant_access') }}
        </r-button>

        <button  @click="$emit('submit', 'delete')" class="btn btn-link" :disabled="d_request.loading">
          {{ $t('button.cancel') }}
        </button>
      </d-col>
    </d-row>
  </d-form>
</template>

<script>
import RedirectRequest from '@/library/RedirectRequest';

export default {
  name: 'auth-consent-form',
  props: {
    scopes: {
      type: Array,
      default: () => [],
    },
    request: {
      type: RedirectRequest,
    }
  },
  data () {
    return {
      d_scopes: [],
      d_scopesToShow: [
        'email',
      ],
      d_request: this.request,
    };
  },
  created () {
    this.d_scopes = this.scopes.filter((scope) => {
      return this.d_scopesToShow.indexOf(scope) !== -1;
    });

    if (!this.d_scopes.length) {
      this.d_scopes = ['default'];
    }
  },
}
</script>
